// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"tableWrapper--jMI+D","actions":"actions--pX37E"};